import actions from "./actions";

const {
  GET_DATA_PRODUCT,
  SET_DATA_PRODUCT,
  DELETE_DATA_PRODUCT,
  EDIT_DATA_PRODUCT,
  GET_DATA_BEGIN,
  GET_DATA_FINISH,
  //NEW
  SET_NEW_DATA_PRODUCT,
  FILTER_BY_PROVIDER,
} = actions;

const initialState = {
  data: [],
  total: 0,
  loading: false,
  filteredproducts: [],
};

const productsReducer = (state = initialState, action: any) => {
  const { type, data } = action;
  switch (type) {
    case GET_DATA_PRODUCT:
      return {
        ...state,
      };
    case SET_DATA_PRODUCT:
      return {
        ...state,
        data: data.results,
        total: data.totalResults,
        filteredProducts: data.results,
        loading: false,
      };
    case DELETE_DATA_PRODUCT:
      return {
        ...state,
        data: [...state.data.filter((person: any) => person.id !== data.id)],
      };
    case EDIT_DATA_PRODUCT:
      const index = state.data.findIndex(
        (person: any) => person.id === data.id
      );
      let newArray: any = [...state.data];
      newArray[index] = data;
      return {
        ...state,
        data: newArray,
      };
    case SET_NEW_DATA_PRODUCT:
      return {
        ...state,
        data: [data, ...state.data],
      };
    case GET_DATA_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FINISH:
      return {
        ...state,
        loading: false,
      };
    case FILTER_BY_PROVIDER:
      return {
        ...state,
        filteredProducts: data,
      };
    default:
      return state;
  }
};
export { productsReducer };
